import { formatMapToOptions } from '@/utils/tool'
import { IS_PRIVATE } from '@/common/const/env'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export enum TerminalType {
  windows = 1,
  linux = 2,
  windowsServer = 3,
  mac = 4,
}

export const TerminalTypeLabel = {
  1: 'Windows',
  2: 'Linux',
  3: 'Server',
  4: 'MacOS',
}

const terminalTypeOptionsBase = formatMapToOptions(TerminalTypeLabel, true).filter(v => !(+v.value === TerminalType.mac && IS_PRIVATE))
const terminalTypeOptionsTempBase = formatMapToOptions(TerminalTypeLabel).filter(v => !(+v.value === TerminalType.mac && IS_PRIVATE))

function filterJpTerminalOptions<T extends { value: string | number }>(list: T[]): T[] {
  if (!IS_JP_ONLY_BUILD) return list
  return list.filter(o => {
    const v = +o.value
    return v === TerminalType.windows //暂时隐藏window server || v === TerminalType.windowsServer
  })
}

export const TerminalTypeOptions = filterJpTerminalOptions(terminalTypeOptionsBase)
export const TerminalTypeOptionsTempList = filterJpTerminalOptions(terminalTypeOptionsTempBase)

/**
 * 分组树 `/terminal-group/team-list` 的 system_types：与 BaseTree 在 terminalType 为空且非公网时传 [] 的行为对齐，避免子分组树缺失。
 * 未在页面上单独指定 `:terminal-type` 时，GroupTreeSelector 默认使用此列表。
 */
export const groupTreeAllSystemTypes: number[] = IS_JP_ONLY_BUILD
  ? [TerminalType.windows ] //日本环境暂时隐藏 TerminalType.windowsServer
  : IS_PRIVATE
    ? [TerminalType.windows, TerminalType.linux, TerminalType.windowsServer]
    : [TerminalType.windows, TerminalType.linux, TerminalType.windowsServer, TerminalType.mac]
